/**
 * Shuttle Thank You Page - GA Purchase Event
 * 
 * Tracks UA Enhanced Ecommerce purchase event on successful payment
 * 
 * @package A2A_Theme
 */

jQuery(document).ready(function($) {
    'use strict';
    
    /**
     * Initialize purchase tracking on thank you page
     */
    function initPurchaseTracking() {
        // Get order data from localStorage (stored during checkout)
        const orderData = getOrderData();
        const bookingData = getBookingData();
        
        if (!orderData || !orderData.id || !bookingData) {
            return;
        }
        
        // Calculate total revenue from order data (includes all extras)
        const revenue = calculateTotalRevenue(orderData, bookingData);
        
        // Get order reference from URL
        const urlParams = new URLSearchParams(window.location.search);
        const orderReference = urlParams.get('reference') || `A2A${orderData.id}`;
        
        // Track the purchase event with order data for accurate pricing
        trackPurchaseEvent(orderData.id, orderReference, revenue, orderData);
    }
    
    /**
     * Track UA purchase event
     */
    function trackPurchaseEvent(orderId, orderReference, revenue, orderData) {
        if (!window.ShuttleGAEvents) {
            return;
        }
        
        const gaEvents = new window.ShuttleGAEvents();
        const bookingData = getBookingData();
        
        if (!bookingData) {
            return;
        }
        
        // Get route_id from selected routes if available
        const routeId = bookingData.selectedRoutes?.outbound?.routeId || 
                       bookingData.selectedRoutes?.outbound?.id || null;
        
        // Track the UA purchase event (STEP 5) with order data for accurate product pricing
        gaEvents.trackPurchaseUA(bookingData, orderId, orderReference, revenue, routeId, orderData);
    }
    
    /**
     * Get booking data from localStorage
     */
    function getBookingData() {
        try {
            const stored = localStorage.getItem('shuttle_booking_data');
            if (stored) {
                return JSON.parse(stored);
            }
        } catch (error) {
            // Silent fail
        }
        return null;
    }
    
    /**
     * Get order data from localStorage
     */
    function getOrderData() {
        try {
            const stored = localStorage.getItem('shuttle_order_data');
            if (stored) {
                return JSON.parse(stored);
            }
        } catch (error) {
            // Silent fail
        }
        return null;
    }
    
    /**
     * Calculate total revenue from order data in EUR
     * Uses the calculated totals that include all extras, fare upgrades, etc.
     * Always returns EUR value regardless of payment currency
     * Returns a number (not a string)
     */
    function calculateTotalRevenue(orderData, bookingData) {
        let total = 0;
        
        // Use calculated totals from order data (includes all extras and upgrades)
        // ALWAYS use price_eur for GA tracking
        if (orderData.calculatedTotals) {
            // Add outbound total in EUR
            if (orderData.calculatedTotals.outbound) {
                total += orderData.calculatedTotals.outbound.price_eur || 0;
            }
            
            // Add return total in EUR if exists
            if (orderData.calculatedTotals.return) {
                total += orderData.calculatedTotals.return.price_eur || 0;
            }
        } else {
            // Fallback: calculate from booking data (basic calculation in EUR)
            const passengers = (bookingData.passengers?.adults || 0) + (bookingData.passengers?.children || 0);
            
            if (bookingData.selectedRoutes?.outbound?.price?.amount) {
                total += bookingData.selectedRoutes.outbound.price.amount * passengers;
            }
            
            if (bookingData.selectedRoutes?.return?.price?.amount) {
                total += bookingData.selectedRoutes.return.price.amount * passengers;
            }
        }
        
        return parseFloat(total.toFixed(2));
    }
    
    // Initialize on page load
    initPurchaseTracking();
});
